import { Button, Divider, Grid, TextField, Tooltip } from "@material-ui/core";
import { EventBusyOutlined, Search } from "@material-ui/icons";
import { ptBR } from "date-fns/locale";
import { memo, useEffect } from "react";
import { DateRangePicker, END_DATE, START_DATE } from "react-nice-dates";
import "react-nice-dates/build/style.css";
import SelectErp from "../../../../components/basics/SelectErp";
import Card from "../../../../components/cards/Card";
import { periods } from "../../../financeiro/constants";
import { taxNotesStatus } from "../constants";
import { useNotaServicoService } from "../context/NotaServicoContext";
import { ClearButton } from "../styles";
import "../styles/style.css";
import SelectFilter from "./SelectFilter";

const Filter = () => {
  const {
    refetch,
    filters,
    cachedCompanies,
    cachedClients,
    setSelectedCompany,
    setSelectedCustomer,
    isCompanyLoading,
    isClientLoading,
    setPeriod,
    filterPeriod,
    setCustomDatePeriod,
    setStatus,
    setNoteNumber,
    setRpsNumber,
  } = useNotaServicoService();

  useEffect(() => {
    (async () => {
      setTimeout(refetch, 1);
    })();
  }, [filters.multipleSort, refetch]);

  return (
    <Grid item xs>
      <Grid
        item
        container
        component={Card}
        direction={"column"}
        style={{
          gap: 24,
          borderLeft: "6px solid #d6e5ff",
          boxSizing: "border-box",
        }}
      >
        <Grid item container xs style={{ gap: 16 }}>
          <Grid item xs>
            <SelectFilter
              filterMatch={filters.multicompany}
              filterOptions={cachedCompanies}
              setFilter={setSelectedCompany}
              label="Empresa"
              loading={isCompanyLoading}
            />
          </Grid>

          <Grid item xs>
            <SelectErp
              label={"Cliente"}
              loading={isClientLoading}
              lg={2}
              onChange={(option) => {
                setSelectedCustomer(option?.value);
              }}
              InputLabelProps={{ shrink: true }}
              placeholder="Busque pela Razão Social do cliente"
              optionsList={cachedClients}
              descriptionField="description"
            />
          </Grid>

          <Grid item xs>
            <TextField
              InputLabelProps={{ shrink: true }}
              label="Nº Nota"
              placeholder="Infome o número da Nota"
              onChange={(event) => setNoteNumber(event.target.value)}
            />
          </Grid>

          <Grid item xs>
            <TextField
              InputLabelProps={{ shrink: true }}
              label="Nº RPS"
              placeholder="Infome o número do RPS"
              onChange={(event) => setRpsNumber(event.target.value)}
            />
          </Grid>
        </Grid>
        <Grid item container xs style={{ gap: 8 }}>
          <Grid item xs={2}>
            <SelectFilter
              label="Status"
              filterMatch={filters.status}
              filterOptions={taxNotesStatus}
              setFilter={setStatus}
            />
          </Grid>

          <Grid item xs={2}>
            <SelectFilter
              label="Periodo de busca"
              filterMatch={filters.period}
              filterOptions={periods}
              setFilter={setPeriod}
            />
          </Grid>
          {filters.period === periods.Personalizado && (
            <Grid item xs={4}>
              <DateRangePicker
                startDate={filterPeriod.startDate}
                endDate={filterPeriod.endDate}
                onStartDateChange={(newDate) => {
                  setCustomDatePeriod({
                    startDate: newDate,
                  });
                }}
                onEndDateChange={(newDate) => {
                  setCustomDatePeriod({
                    endDate: newDate,
                  });
                }}
                minimumLength={0}
                format="dd/MM/yyyy"
                weekdayFormat="EEEEE"
                locale={ptBR}
                maximumLength={365}
              >
                {({ startDateInputProps, endDateInputProps, focus }) => (
                  <div
                    className="date-range"
                    style={{
                      display: "flex",
                      gap: 16,
                    }}
                  >
                    <TextField
                      size="small"
                      label="Data inicial"
                      className={
                        "input" + (focus === START_DATE ? " -focused" : "")
                      }
                      {...startDateInputProps}
                      placeholder="Ex: 01/12/2022"
                    />
                    <TextField
                      size="small"
                      label="Data final"
                      className={
                        "input" + (focus === END_DATE ? " -focused" : "")
                      }
                      {...endDateInputProps}
                      placeholder="Ex: 31/12/2022"
                    />
                    <Tooltip title="Limpar filtro de datas">
                      <ClearButton
                        size="small"
                        onClick={() =>
                          setCustomDatePeriod({
                            startDate: undefined,
                            endDate: undefined,
                          })
                        }
                      >
                        <EventBusyOutlined />
                      </ClearButton>
                    </Tooltip>
                  </div>
                )}
              </DateRangePicker>
            </Grid>
          )}
          <Grid item xs />
        </Grid>

        <Divider />
        <Grid item xs container direction="row" spacing={2}>
          <Grid item xs>
            <Button
              size="small"
              color="primary"
              variant="contained"
              startIcon={<Search />}
              onClick={async () => {
                await refetch();
              }}
            >
              Gerar relatório
            </Button>
          </Grid>
        </Grid>
      </Grid>
    </Grid>
  );
};

export default memo(Filter);
